module.exports = require("@swa-ui/dotcom/src/DesktopHeaderControl/DesktopHeaderControl.module.scss");